// TODO: @ngan please rename this to avoid conflict with @react-oauth/google's hasGrantedAllScopesGoogle
export const hasGrantedAllScopesGoogle = (requestedScopes: string, grantedScopes: string) => {
  // Convert granted scopes string to an array
  const grantedScopesArray = grantedScopes.split(' ');
  const requestedScopesArray = requestedScopes.split(' ');

  // Check if all requested scopes are in the granted scopes
  return requestedScopesArray.every((scope) => grantedScopesArray.includes(scope));
};
